// extracted by mini-css-extract-plugin
export default {"page":"Connect_page__4OdWG","connect":"Connect_connect__eW-GN","detail":"Connect_detail__niUFT","screen":"Connect_screen__J0u5u"};